import { defaultCounterVariantIcon } from '../icons';
import { DEFAULT_CSS_CLASS } from '@constants';

const defaultBlockCssClass = DEFAULT_CSS_CLASS.COUNTER;

const defaultCounter = {
  name: 'default-counter',
  title: 'Default Counter',
  icon: defaultCounterVariantIcon,
  scope: ['block'],
  isDefault: true,
  attributes: {
    blockClassNames: [
      {
        value: `${defaultBlockCssClass}--dlt`,
        label: 'Dlt',
      },
    ],
  },
  innerBlocks: [
    [
      'core/heading',
      {
        placeholder: 'Title',
        level: 2,
        className: `${defaultBlockCssClass}__t`,
      },
    ],
    [
      'b3rg/div',
      {},
      [
        [
          'b3rg/span',
          {
            blockClassNames: [
              { value: `${defaultBlockCssClass}__p`, label: 'Prefix' },
            ],
          },
          [
            [
              'core/paragraph',
              {
                placeholder: 'Prefix',
              },
            ],
          ],
        ],
        ['b3rg/count', {}],
        [
          'b3rg/span',
          {
            blockClassNames: [
              { value: `${defaultBlockCssClass}__u`, label: 'Unit' },
            ],
          },
          [
            [
              'core/paragraph',
              {
                placeholder: 'Unit',
              },
            ],
          ],
        ],
        [
          'b3rg/span',
          {
            blockClassNames: [
              { value: `${defaultBlockCssClass}__s`, label: 'Suffix' },
            ],
          },
          [
            [
              'core/paragraph',
              {
                placeholder: 'Suffix',
              },
            ],
          ],
        ],
      ],
    ],
    [
      'core/paragraph',
      {
        placeholder: 'Description',
        className: `${defaultBlockCssClass}__d`,
      },
    ],
  ],
};

export default defaultCounter;
